/**
 * Search page caches query, filters, and results in sessionStorage so navigation
 * within a session doesn't lose state. Keys must be scoped per user so a new
 * login/register doesn't inherit another user's (or anonymous) cached search.
 */

const USER_EMAIL_KEY = "gradconnect_user_email";

const LEGACY_KEYS = [
  "searchQuery",
  "searchResults",
  "selectedDepartments",
  "selectedSchools",
  "currentPage",
  "totalPages",
];

/** Stable prefix per authenticated identity (email preferred; token slice fallback). */
export function getSearchSessionPrefix() {
  const email = localStorage.getItem(USER_EMAIL_KEY);
  if (email) {
    return `gradconnect_search_${email.replace(/[^a-zA-Z0-9]/g, "_")}`;
  }
  const token = localStorage.getItem("authToken");
  if (token && token.length > 24) {
    return `gradconnect_search_${token.slice(0, 12)}_${token.slice(-12)}`;
  }
  return "gradconnect_search_anon";
}

export function searchSessionKey(name) {
  return `${getSearchSessionPrefix()}_${name}`;
}

/** Old unscoped keys — remove after login/register so they don't leak across users. */
export function clearLegacySearchSessionStorage() {
  LEGACY_KEYS.forEach((k) => sessionStorage.removeItem(k));
}

export function setLoggedInUserEmail(email) {
  if (email) {
    localStorage.setItem(USER_EMAIL_KEY, email);
  }
}

export function clearLoggedInUserEmail() {
  localStorage.removeItem(USER_EMAIL_KEY);
}
